import { render, staticRenderFns } from "./CollectedPoints.vue?vue&type=template&id=07877a0e&scoped=true&"
import script from "./CollectedPoints.vue?vue&type=script&lang=js&"
export * from "./CollectedPoints.vue?vue&type=script&lang=js&"
import style0 from "./CollectedPoints.vue?vue&type=style&index=0&id=07877a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07877a0e",
  null
  
)

export default component.exports